import React from "react"
import { ReactComponent as ChevronIcon } from "@icons/chevron.svg"
import { ColumnInstance } from "react-table"
import styled, { css } from "styled-components"
import { modifier } from "@styles/mixins"
import { colors } from "@styles/vars"

export default function Sort<T extends object>({ column }: SortProps<T>) {
    return (
        <Wrapper isSorted={column.isSorted} isSortedDesc={column.isSortedDesc}>
            <ChevronIcon />
        </Wrapper>
    )
}

// STYLES
const Wrapper = styled.span<SortModifiers>`
    opacity: 0;
    transition: 0.4s ease-out;
    width: 24px;
    height: 24px;
    margin-left: 5px;
    opacity: 1;

    svg {
        width: 24px;
        height: 24px;
        fill: ${colors.black};
        opacity: .6;

        ${modifier("isSorted", css`
            opacity: 1;
        `)}
    }

    ${modifier("isSorted", css`
        display: inline-block;
        transform: rotate(180deg);
        
        ${modifier("isSortedDesc", css`
            transform: none;
        `)}
    `)}
`

// TYPES
interface SortProps<T extends object> {
    column: ColumnInstance<T>
}

interface SortModifiers {
    isSorted: boolean
    isSortedDesc?: boolean
}